export enum LightBehavior {
	On = 'ON',
	Flashing = 'FLASHING',
	Off = 'OFF'
}

export enum LightingRingStyle {
	Segment = 'SEGMENT',
	Ring = 'RING'
}

export enum LightingState {
	Muted = 'MUTED',
	Unmuted = 'UNMUTED'
}

export enum GateOffBehavior {
	Off = 'OFF',
	FollowMuteColor = 'FOLLOW_MUTE_COLOR'
}

export enum LightColor {
	Blue = 'BLUE',
	Cyan = 'CYAN',
	Gold = 'GOLD',
	Green = 'GREEN',
	LightPurple = 'LIGHT_PURPLE',
	Orange = 'ORANGE',
	Orchid = 'ORCHID',
	Pink = 'PINK',
	PowderBlue = 'POWDER_BLUE',
	Purple = 'PURPLE',
	Red = 'RED',
	SkyBlue = 'SKY_BLUE',
	Turquoise = 'TURQUOISE',
	Violet = 'VIOLET',
	White = 'WHITE',
	Yellow = 'YELLOW',
	YellowGreen = 'YELLOW_GREEN'
}

export const colorToHex: Record<string, string> = {
	[LightColor.Red]: '#FF482A',
	[LightColor.Orange]: '#FF9630',
	[LightColor.Gold]: '#FFD700',
	[LightColor.Yellow]: '#FFF32C',
	[LightColor.YellowGreen]: '#D8FF00',
	[LightColor.Green]: '#3CFC22',
	[LightColor.Turquoise]: '#40e0d0',
	[LightColor.PowderBlue]: '#B0E0E6',
	[LightColor.Cyan]: '#00FFFF',
	[LightColor.SkyBlue]: '#00BFFF',
	[LightColor.Blue]: '#266EFF',
	[LightColor.Purple]: '#C48FFF',
	[LightColor.LightPurple]: '#D2A5FF',
	[LightColor.Violet]: '#EE82EE',
	[LightColor.Orchid]: '#DA70D6',
	[LightColor.Pink]: '#FF5AB3',
	[LightColor.White]: '#FFFFFF'
};

export const colorToMatrix: Record<string, string> = {
	[LightColor.Red]: '0 0 0 0 1.00 0 0 0 0 0.28 0 0 0 0 0.16 0 0 0 1 0',
	[LightColor.Orange]: '0 0 0 0 1.00 0 0 0 0 0.59 0 0 0 0 0.19 0 0 0 1 0',
	[LightColor.Gold]: '0 0 0 0 1.00 0 0 0 0 0.84 0 0 0 0 0.00 0 0 0 1 0',
	[LightColor.Yellow]: '0 0 0 0 1.00 0 0 0 0 0.95 0 0 0 0 0.17 0 0 0 1 0',
	[LightColor.YellowGreen]: '0 0 0 0 0.85 0 0 0 0 1.00 0 0 0 0 0.00 0 0 0 1 0',
	[LightColor.Green]: '0 0 0 0 0.24 0 0 0 0 0.99 0 0 0 0 0.13 0 0 0 1 0',
	[LightColor.Turquoise]: '0 0 0 0 0.25 0 0 0 0 0.88 0 0 0 0 0.82 0 0 0 1 0',
	[LightColor.PowderBlue]: '0 0 0 0 0.69 0 0 0 0 0.88 0 0 0 0 0.90 0 0 0 1 0',
	[LightColor.Cyan]: '0 0 0 0 0.00 0 0 0 0 1.00 0 0 0 0 1.00 0 0 0 1 0',
	[LightColor.SkyBlue]: '0 0 0 0 0.00 0 0 0 0 0.75 0 0 0 0 1.00 0 0 0 1 0',
	[LightColor.Blue]: '0 0 0 0 0.15 0 0 0 0 0.43 0 0 0 0 1.00 0 0 0 1 0',
	[LightColor.Purple]: '0 0 0 0 0.77 0 0 0 0 0.56 0 0 0 0 1.00 0 0 0 1 0',
	[LightColor.LightPurple]: '0 0 0 0 0.82 0 0 0 0 0.65 0 0 0 0 1.00 0 0 0 1 0',
	[LightColor.Violet]: '0 0 0 0 0.93 0 0 0 0 0.51 0 0 0 0 0.93 0 0 0 1 0',
	[LightColor.Orchid]: '0 0 0 0 0.85 0 0 0 0 0.44 0 0 0 0 0.84 0 0 0 1 0',
	[LightColor.Pink]: '0 0 0 0 1.00 0 0 0 0 0.35 0 0 0 0 0.70 0 0 0 1 0',
	[LightColor.White]: '0 0 0 0 1.00 0 0 0 0 1.00 0 0 0 0 1.00 0 0 0 1 0'
};
